import { Component, Input, Output, EventEmitter } from '@angular/core';
import { WFWorker, WorkerWithProfile } from 'globals/store/workforce.data';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'potential-owners',
    template: `
<icon class="drop" [matMenuTriggerFor]="potentialOwnersMenu" matIcon='arrow_drop_down'></icon>
<mat-menu #potentialOwnersMenu="matMenu" xPosition="before">
  <h5>Current Owner</h5>
  <button mat-menu-item class="holder owner">
    <div style="flex:1"></div>
    <div class="owner_name">{{ currentOwner.firstName + ' ' + currentOwner.lastName }}</div>
    <div class="owner_email">{{ currentOwner.email }}</div>
    <div style="flex:1"></div>
  </button>
  <hr />
  <h5>Change Owner</h5>
  <button class="holder" *ngFor="let p of potentialOwners" mat-menu-item (click)="changeOwner.emit(p)">
    <div style="flex:1"></div>
    <div class="owner_name">{{ p.firstName + ' ' + p.lastName }}</div>
    <div class="owner_email">{{ p.email }}</div>
    <div style="flex:1"></div>
  </button>
</mat-menu>
`,
    styles: [`
  icon { cursor: pointer; }
  .change_owner { font-size: 14px; margin: auto; padding: 5px 15px; color: var(--normal-text); }
  .holder { line-height: normal; display: flex; flex-direction: column; height: 48px; }
  .holder.owner { pointer-events: none; }
  .owner_email { color: #999; font-size: 12px; }
  .current_owner { display: flex; }
  h5 { margin: 10px 15px 5px; }
`],
    standalone: true,
    imports: [CommonModule, IconComponent, MatMenuModule],
})
export class PotentialOwnersSelector {
  @Input() potentialOwners: WFWorker[] | WorkerWithProfile[] = []
  @Input() currentOwner: WFWorker
  @Output() changeOwner: EventEmitter<WFWorker> = new EventEmitter()
}

